export { default } from './LinedTable'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Tables/LinedTable/index.js